import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BrandLogo } from "@/lib/brand";
import { getFooter } from "../lib/catalogueApi";

// T63: editable footer (Admin > Content > Footer). Plain text + validated links only: never raw HTML.
export const FOOTER_DEFAULT = {
  about: "Australian-owned technology retailer supplying quality laptops, computers, IT hardware and business technology solutions. From everyday essentials to enterprise-grade equipment, we help individuals and businesses stay equipped for what's next.",
  columns: [{ heading: "Policies", links: [{ label: "Privacy Policy", href: "/policies/privacy" }, { label: "Terms of Sale", href: "/policies/terms" }, { label: "Returns & Refunds", href: "/policies/returns" }] }], contact_lead: "Need a business quote?", contact_email: "sales@rhytestepit.com.au", contact_phone: "", pricing_note: "Prices shown in AUD and include GST.", copyright: "",
};
let last = null;
const year = String(new Date().getFullYear());
const FLink = ({ href, children, testid }) => (/^https:\/\//.test(href)
  ? <a href={href} target="_blank" rel="noopener noreferrer" className="hover:text-[var(--brand-link)] hover:underline" data-testid={testid}>{children}</a>
  : <Link to={href} className="hover:text-[var(--brand-link)] hover:underline" data-testid={testid}>{children}</Link>);

export function SiteFooter({ f, variant = "auto" }) {
  const ph = variant === "phone";
  const cols = (f.columns || []).filter((c) => c.heading || c.links?.length);
  const bottom = [f.copyright?.replace("{year}", year), f.pricing_note].filter(Boolean);
  return (
    <footer className="mt-16 border-t border-slate-200 bg-white text-slate-600" data-testid="site-footer">
      <div className={`mx-auto max-w-6xl px-5 py-10 text-sm ${ph ? "flex flex-col gap-8" : "flex flex-col gap-8 md:flex-row md:flex-wrap md:justify-between"}`}>
        <div className="max-w-sm">
          <BrandLogo height={36} testid="footer-logo" />
          {f.about && <p className="mt-2 text-slate-500" data-testid="footer-about">{f.about}</p>}
        </div>
        {cols.map((c, i) => (
          <nav key={i} aria-label={c.heading || `Footer links ${i + 1}`} data-testid={`footer-col-${i}`}>
            {c.heading && <h2 className="mb-2 text-sm font-bold text-[var(--brand-primary)]">{c.heading}</h2>}
            <ul className="space-y-1.5">{(c.links || []).map((l, j) => <li key={j}><FLink href={l.href} testid={`footer-link-${i}-${j}`}>{l.label}</FLink></li>)}</ul>
          </nav>
        ))}
        {(f.contact_lead || f.contact_email || f.contact_phone) && (
          <div className="text-slate-500" data-testid="footer-contact">
            <div>{f.contact_lead}{f.contact_lead && (f.contact_email || f.contact_phone) ? " " : ""}{f.contact_email && <span className="text-[var(--brand-link)]" data-testid="footer-email">{f.contact_email}</span>}</div>
            {f.contact_phone && <div className="mt-1" data-testid="footer-phone">{f.contact_phone}</div>}
          </div>
        )}
      </div>
      {bottom.length > 0 && (
        <div className="border-t border-slate-100" data-testid="footer-bottom">
          <div className={`mx-auto flex max-w-6xl gap-x-6 gap-y-1 px-5 py-4 text-xs text-slate-500 ${ph ? "flex-col" : "flex-col sm:flex-row sm:flex-wrap sm:justify-between"}`}>
            {f.copyright && <span data-testid="footer-copyright">{f.copyright.replace("{year}", year)}</span>}
            {f.pricing_note && <span data-testid="footer-pricing-note">{f.pricing_note}</span>}
          </div>
        </div>
      )}
    </footer>
  );
}

export function StoreFooter() {
  const [f, setF] = useState(last || FOOTER_DEFAULT);
  useEffect(() => { getFooter().then((d) => { last = d; setF(d); }).catch(() => {}); }, []);
  return <SiteFooter f={f} />;
}
